// src/services/api.js
import { isClientes, isProduction } from '../config/constants';
import { auth } from '../config/firebase';
import axios from 'axios';

// Base URL del servidor backend
const API_URL = isProduction ? 'https://dufy-asesorias-api.46fbym.easypanel.host/api' :'http://localhost:8080/api';  

//espera de 2 segundos
const delay = ms => new Promise(res => setTimeout(res, ms));
//obtener nombreEmpresa con espera maxima de 2 segundos
export const obtenerNombreEmpresaConReintentos = async () => {
    console.log("obtener nombre de empresa");
    const MAX_INTENTOS = 3;
    const TIEMPO_ESPERA = 2000; // 2 segundos

    for (let i = 0; i < MAX_INTENTOS; i++) {
        const nombreEmpresa = localStorage.getItem('nombreEmpresa');
        
        // Si se encuentra un valor, se devuelve inmediatamente.
        if (nombreEmpresa && nombreEmpresa.trim() !== '') {
            console.log(`✅ Nombre de empresa encontrado en intento #${i + 1}: "${nombreEmpresa}"`);
            return nombreEmpresa;
        }
        
        // Si no es el último intento, se espera antes de volver a probar.
        if (i < MAX_INTENTOS - 1) {
            console.warn(`Intento #${i + 1}: 'nombreEmpresa' no encontrado. Esperando ${TIEMPO_ESPERA / 1000}s...`);
            await delay(TIEMPO_ESPERA);
        }
    }

    // Si el bucle termina sin encontrar el valor, se usa el valor por defecto.
    console.error(`❌ No se encontró 'nombreEmpresa' tras ${MAX_INTENTOS} intentos. Usando valor por defecto.`);
    return null;
}

// Configuración de axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

//interceptor asincronico
api.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;

    if(user) {
      const token = await user.getIdToken();
      config.headers['Authorization'] = `Bearer ${token}`;
      const retrievedCompanyName = await obtenerNombreEmpresaConReintentos();

      if (retrievedCompanyName) {
        config.headers['x-company-name'] = retrievedCompanyName;
        config.headers['iscliente'] = isClientes;
      }

    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }

)

//api de tutores
export const tutoresApi = {
  //crear prospecto por formulario
  createProspecto: async(tutorData,contrasena) =>{
    try{

      const dataToSend = {
        ...tutorData,  // Spread all tutor data
        contrasena: contrasena  // Add the password at the top level
      };

      const response = await api.post(`/tutores/addProspecto`, dataToSend);
      if (response.data && response.data.success) {

        return {
          success: true,
          message: response.data.message,
        };
      } else {

        return {
          success: false,
          message: response.data.message || 'Error al enviar la cotización'
        };
      }
    }
    catch(error){
      console.error('Error al obtener añadir tutor:', error);
      throw error;
    }
  },
  //add info faltante
  addRegistroCompletoProspecto: async(tutorDataFaltante,usuario) =>{
    try{
      const formData = new FormData();
      formData.append('hojadevida', tutorDataFaltante.hojadevida);
      formData.append('fotoPerfil', tutorDataFaltante.fotoPerfil);
      const datosLimpios = { ...tutorDataFaltante };
      delete datosLimpios.hojadevida;
      delete datosLimpios.fotoPerfil;
      formData.append('tutorData', JSON.stringify(datosLimpios));
      formData.append('usuarioData', JSON.stringify(usuario));


      // Enviar todo en una sola petición
      const response = await api.post('/tutores/addRegistroCompletoProspecto', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al enviar información, notifica al administrador'
        };
      }

    }
    catch(error){
      console.error('Error al obtener añadir registro completo prospecto:', error);
      console.log("error",error);
      throw error;
    }

  },
  //obtener tutor por uid
  getById: async(uid, nombreEmpresa ="") =>{
    console.log("cargar tutor uid",uid);
    const nombreEmpresaElegida = nombreEmpresa === "" 
      ? await obtenerNombreEmpresaConReintentos() 
      : nombreEmpresa;
      
    try{
      const response = await api.get(`/tutores/obtenerPorUid/${uid}/${nombreEmpresaElegida}`);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener usuario ${uid}:`, error);
      throw error;
    }
  },
  //obtener tutores
  getTutores: async() =>{
    try{
      const response = await api.get(`/tutores/obtenerTutores`);
      console.log("obteniendo tutoires",response);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de tutores :`, error);
      throw error;
    }
  },
  //obtener prospectos
  getProspectos: async() =>{
    try{
       const response = await api.get(`/tutores/obtenerProspectos`);
       return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de prospectos :`, error);
      throw error;
    }
  },
  //obtener colaboradores
  getColaboradores: async(nombreEmpresa) =>{
    try{
      const response = await api.get(`/tutores/obtenerAdministradores/${nombreEmpresa}`);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de colaboradores :`, error);
      throw error;    
    }
  },
  //get tutores por materia
  getTutoresporMateria: async(materia) =>{
    try{
      const response = await api.get(`/tutores/obtenerTutoresPorMateria/${materia}`);
      console.log("obtener tutores por materia",response);
      return response.data.data;

    }
    catch(error){
      console.error(`Error al obtener lista de tutores :`, error);
      throw error;
    }
  },
  //update tutor
  updateTutor: async(nombreEmpresa, uidTutor , type, updateData) =>{
    console.log("update tutor",nombreEmpresa,uidTutor,type,updateData);
    try{
      const response = await api.post(`/tutores/updateTutor/${nombreEmpresa}/${uidTutor}/${type}`, updateData);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al actualizar la solicitud'
        };
      }

    }
    catch(error){
      console.error('Error al actualizar el tutor:', error);
      return {
          success: false,
          message: error || 'Error al actualizar el tutor'
        };
    }

  },
  //update tutor con archivo
  updateTutorArchivo: async(nombreEmpresa, uidTutor , type, updateData, archivo) =>{
    try{
      console.log("update tutora rchivo",archivo);
      const formData = new FormData();
      formData.append('archivos', archivo);
      formData.append('updateData', JSON.stringify(updateData));

      console.log("formData",formData);

      const response = await api.post(`/tutores/updateTutorArchivos/${nombreEmpresa}/${uidTutor}/${type}`, formData , {
         headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al actualizar la solicitud'
        };
      }

    }
    catch(error){
      console.error('Error al actualizar el tutor:', error);
      return {
          success: false,
          message: error || 'Error al actualizar el tutor'
        };
    }
  },
  //generar prueba prospecto
  generarPruebaProspecto: async(materiasSeleccionadas,uidTutor) =>{
    try{
      const response = await api.post(`/tutores/generarPruebaTutor/${materiasSeleccionadas}/${uidTutor}`);

      if (response.data && response.data.success) {

        return {
          success: true,
          message: response.data.message,
        };
      } else {

        return {
          success: false,
          message: response.data.message || 'Error al generar prueba'
        };
      }

    }
    catch(error){
      console.error('Error al generar prueba para prospecto:', error);
      throw error;
    }
  },
  //obtener estadisticas
  getEstadisticaTutor: async(nombreTutor) =>{
    try{
      const response = await api.get(`/tutores/getEstadisticasTutor/${nombreTutor}`);

       return response.data;
    }
    catch(error){
      console.error(`Error al obtener estadisticas de usuario ${nombreTutor}:`, error);
      throw error;
    }
  },
  //entregar examen
  entregaExamenProspecto: async (uid, examenes,totalExamenes) => {
    try {
      const formData = new FormData();
      formData.append('totalExamenes', JSON.stringify(totalExamenes));
      for (const materia in examenes) {
        if (examenes[materia]) {
          formData.append(materia, examenes[materia]);
        }
      }

      console.log("🚀 Enviando FormData al backend...");
      for (let [key, value] of formData.entries()) {
        console.log(`  - ${key}:`, value);
      }

      // 👇 AÑADE ESTE TERCER ARGUMENTO, IGUAL QUE EN TU OTRA FUNCIÓN
      const response = await api.post(
        `/tutores/entregaTrabajo/${uid}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          } 
        }
      );

      return response.data;
      
    } catch(error) {
      console.error(`Error al entregar examen del prospecto:`, error);
      throw error;
    }
  },
}
//api de solicitudes
export const solicitudesApi = {
  //solciitudes disponibles, util para admin y tutores
  getSolicitudesDisponibles: async() => {
    try {
      const response = await api.get('/solicitudes/getSolicitudesDisponibles');
      const data = response.data.data;
      return response.data.data; // Retorna directamente el array de solicitudes
    } catch(error) {
      console.error('Error al obtener solicitudes:', error);
      throw error;
    }
  },
  //solicitudes by id, para detalles solicitud
  getSolicitudPorId: async (id, nombreEmpresa, publicId ) => {
    try {
      // Usamos ambos parámetros en la URL
      const response = await api.get(`/solicitudes/getSolicitudPorId/${nombreEmpresa}/${id}?publicId=${publicId}`);
      
      // Si la respuesta tiene una estructura anidada como response.data.data
      if (response.data && response.data.data) {
        return response.data.data;
      }
      
      // Si la respuesta está directamente en response.data
      return response.data;
    } catch (error) {
      console.error('Error al obtener la solicitud:', error);
      throw error;
    }
  },
  //obtener cotizaciones de tutor
  getTutorCotizaciones: async (tutorId, page = 1, limit = 10) => {

    try {
      let url = `/solicitudes/tutor-cotizaciones?tutorId=${tutorId}&limit=${limit}&page=${page}`;
      
      const response = await api.get(url);
            
      if (response.data && response.data.success) {
        return {
          cotizaciones: response.data.data,
          hasMore: response.data.pagination.hasMore,
          nextPage: response.data.pagination.nextPage // El backend envía 'nextPage' como número
        };
      } else {
        throw new Error(response.data?.message || 'Error al obtener cotizaciones');
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Error desconocido';
      throw new Error(`Error al obtener cotizaciones: ${errorMessage}`);
    }
  },
  //cotizar solicitud
  addCotizacion: async(id,nombreEmpresa,cotizacionData,cambiadoPor) =>{
    try{
      const response = await api.post(`/solicitudes/addCotizacion/${nombreEmpresa}/${id}/${cambiadoPor}`, cotizacionData);

      // Verificar si la solicitud fue exitosa
    if (response.data && response.data.success) {
      return {
        success: true,
        message: response.data.message,
        solicitudId: response.data.solicitudId
      };
    } else {
      // Si la API respondió, pero no fue exitoso
      return {
        success: false,
        message: response.data.message || 'Error al enviar la cotización'
      };
    }
      
    }
    catch(error){
      console.error('Error al enviar la cotización:', error);
    
      // Extraer el mensaje de error del servidor si está disponible
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : 'Error al conectar con el servidor';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //añadir solcitud
  addSolicitud: async (nombreEmpresa, solicitudData, archivos = []) => {
    try {      
      const formData = new FormData();
      
      console.log("el add solciitud es",solicitudData,nombreEmpresa);

      
      // LIMPIAR contenido de placeholders antes de enviar VER SI BORRAR
      if (solicitudData.contenidoEnriquecido) {
        const contenidoLimpio = solicitudData.contenidoEnriquecido.filter(item => {
          if (item.insert && typeof item.insert === 'object') {
            return !(
              item.insert.__archivo_placeholder__ !== undefined ||
              item.insert.archivo_placeholder !== undefined ||
              item.insert['__archivo_placeholder__'] !== undefined
            );
          }
          return true;
        });
        
        console.log("🧹 Contenido limpio:", contenidoLimpio.length, "items");
        solicitudData.contenidoEnriquecido = contenidoLimpio;
      }
      
      // Agregar datos de la solicitud
      formData.append('solicitudData', JSON.stringify(solicitudData));
      
      // Agregar archivos
      archivos.forEach((archivo, index) => {
        formData.append('archivos', archivo);
        console.log(`📎 Archivo ${index + 1}: ${archivo.name} (${archivo.size} bytes)`);
      });

      // --- CÓDIGO DE DEPURACIÓN ---
      console.log("🕵️  Inspeccionando FormData antes de enviar:");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`- ${key}: [Archivo] ${value.name}, Tamaño: ${value.size} bytes`);
        } else {
          // Si el valor es texto, mide su longitud para ver si es muy grande
          console.log(`- ${key}: [Texto] Longitud: ${value.length}`);
          // Opcional: muestra una parte del texto para identificarlo
          // console.log(`   Contenido (parcial): ${value.substring(0, 100)}...`);
        }
      }
      // ----------------------------
                  
      const response = await api.post(`/solicitudes/addSolicitud/${nombreEmpresa}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al enviar la solicitud'
        };
      }
        
        
    } catch (error) {
      console.error('Error en addSolicitudConArchivos:', error);
      
      const errorMessage = error.response?.data?.message || error.message || 'Error al conectar con el servidor';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //update solicitud
  updateSolicitud: async(id,nombreEmpresa,updateData,type,cambiadopor) =>{
    console.log("update solicitud",id,nombreEmpresa,updateData,type);
    try{
      
      const response = await api.post(`/solicitudes/updateSolicitud/${nombreEmpresa}/${id}/${type}/${cambiadopor}`, updateData);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
          solicitudId: response.data.solicitudId
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al actualizar la solicitud'
        };
      }
        
      return true;

    }
    catch(error){
      console.error('Error al actualizar la solicitud:', error);
    
      // Extraer el mensaje de error del servidor si está disponible
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : 'Error al actualizar la solicitud';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //update contenido enriquecido solicitud
  updateContenidoEnriquecido: async(id,nombreEmpresa,contenidoEnriquecido,archivos =[],cambiadopor) =>{
    try{
      console.log("tenemos para enviar",id,nombreEmpresa,contenidoEnriquecido);
      const formData = new FormData();
      formData.append('contenidoEnriquecido', JSON.stringify(contenidoEnriquecido));

      // Agregar archivos
      archivos.forEach((archivo, index) => {
        formData.append('archivos', archivo);
        console.log(`📎 Archivo ${index + 1}: ${archivo.name} (${archivo.size} bytes)`);
      });

      const response = await api.post(`/solicitudes/updateContenidoEnriquecido/${nombreEmpresa}/${id}/${cambiadopor}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

       if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al actualizar contenido enriquecido de solicitud'
        };
      }

    }
    catch(error){
      console.error('Error en update contenido enriquecido:', error);
      
      const errorMessage = error.response?.data?.message || error.message || 'Error al conectar con el servidor';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //Eliminar cotizacion
  deleteCotizacion: async(nombreEmpresa,id,cotizacionData,cambiadoPor) =>{
    try{

      console.log("a eliminar cotizacion",nombreEmpresa,id,cotizacionData);
      
      const response = await api.post(`/solicitudes/delete-cotizacion/${nombreEmpresa}/${id}/${cambiadoPor}`, cotizacionData);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
        };
      } else{
        return {
          success: false,
          message: response.data.message || 'Error al enviar la cotización'
        };
      }

    }
    catch(error){
      console.error('Error al eliminar la cotizacion', error);
      return {
        success: false,
        message: error,
        error: error
      };
    }
  },
  //obtener solicitudes de un cliente
  getSolicitudesCliente: async(nombreEmpresa,numeroCLiente) =>{
    try{
      const response = await api.get(`/solicitudes/getSolicitudesCliente/${nombreEmpresa}/${numeroCLiente}`);
      const data = response.data.data;
      return data;
    }
    catch(error){
      console.error('Error al obtener la solicitudes para un cliente:', error);
      throw error;
    }
  },
  notificarSolicitud: async(solicitudData) =>{
    try{

    // REVISAR TIPOS DE DATOS POR FIELD
    console.log('=== TIPOS DE DATOS POR FIELD ===');
    
    Object.entries(solicitudData).forEach(([field, value]) => {
      let tipo = typeof value;
      
      // Verificar casos especiales
      if (value === null) {
        tipo = 'null';
      } else if (Array.isArray(value)) {
        tipo = 'array';
      } else if (value instanceof Date) {
        tipo = 'Date';
      }
      
      console.log(`${field} - ${tipo}`);
    });

      const response = await api.post(`/solicitudes/envioMensajesSolicitud`, solicitudData);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
          solicitudId: response.data.solicitudId
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al actualizar la solicitud'
        };
      }
      
    }
    catch(error){
      console.error('Error al notificar solicitud:', error);
    
      // Extraer el mensaje de error del servidor si está disponible
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : 'Error al notificar la solicitud';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //add pago para solicitud
  addPagoSolicitud: async(pagoData, nombreEmpresa ,codigo, cambiadopor) =>{
    try{
      console.log("a enviar pagodata",pagoData);
      const formData = new FormData();
      formData.append('archivoPago', pagoData.archivoPago);
      const datosLimpios = { ...pagoData };
      delete datosLimpios.archivoPago;
      delete datosLimpios.id;
      formData.append('pagoData', JSON.stringify(datosLimpios));

      const response = await api.post(`/solicitudes/addPago/${nombreEmpresa}/${codigo}/${cambiadopor}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      console.log("responde datao",response);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al añadir pago'
        };
      }

    }
    catch(error){
      console.error('Error al añadir pago:', error);
      console.log("error",error);
      return {
          success: false,
          message: error.response.data.message || 'Error al añadir pago'
        };
    }
  },
  //eliminar pagos de una solicitud
  deletePagoSolicitud: async(nombreEmpresa,idSolicitud,PagoId,cambiadopor) =>{
    try{

      const response = await api.post(`/solicitudes/deletePago/${nombreEmpresa}/${idSolicitud}/${PagoId}/${cambiadopor}`);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
        };
      } else{
        return {
          success: false,
          message: response.data.message || 'Error al eliminar el pago'
        };
      }

    }
    catch(error){
      console.error('Error al eliminar pago:', error);
      console.log("error",error);
      return {
          success: false,
          message: error.response.data.message || 'Error al eliminar pago en deletePagoSolicitud'
        };
    }
  }

}
//api de listas
export const obtenerListas = {
  //obtener materias
  getAllMaterias: async() =>{
    try{
      const response = await api.get('/listas/obtenerMaterias');
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener materias:', error);
      throw error;
    }
  },
  //obtener universidades
  getUniversidades: async() =>{
    try{
      const response = await api.get('/listas/obtenerUniversidad');
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener materias:', error);
      throw error;
    }
  },
  //obtener carreras
  getCarreras: async() =>{
    try{
      const response = await api.get('/listas/obtenerCarrera');
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener materias:', error);
      throw error;
    }
  },
  //obtener materias pro plataforma
  getMateriasProPlataforma: async() =>{
    try{
      const response = await api.get('/listas/obtenerMateriasProPlataforma');
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener materias:', error);
      throw error;
    }
  },
  //obtener fases pro plataforma
  getFasesProPlataforma: async() =>{
     try{
      const response = await api.get('/listas/obtenerFasesProPlataforma');
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener materias:', error);
      throw error;
    }
  },
  //get plataforma pro platforma
  getPlataformaProPlataforma: async() =>{
    try{
      const response = await api.get('/listas/obtenerPlataformaProPlataforma');
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener materias:', error);
      throw error;
    }
  },
  //get semestres pro plataforma
  getSemestreProPlataforma: async() =>{
    try{
      const response = await api.get('/listas/obtenerSemestresProPlataforma');
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener materias:', error);
      throw error;
    }
  },
  //obtener examenes de tutor
  getPruebasExamenesTutores: async() =>{
    try{
      const response = await api.get('/listas/obtenerPruebasNuevosTutores');
      console.log("obtenido response examenes",response);
      const data = response.data.data;
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtenerPruebasNuevosTutores:', error);
      throw error;
    }
  }

}
//api de contabilidad
export const contabilidadApi = {
  obtenerserviciosTutor : async(nameTutor) =>{
    try{
      const response = await api.get(`/contabilidad/getServiciosDisponibles?nameTutor=${encodeURIComponent(nameTutor)}`);
      return response.data.data ?? []; // Retorna directamente el array de solicitudes
    }
    catch(error){
      console.error('Error al obtener servidios de tutoir:', error);
      throw error;
    }
  },
  //obtener servicio por codigo
  obtenerServicioPorId : async(codigo,nombreEmpresa) =>{
    //debemos pasar el nametutor o algo, si o si el servicio debe ser del tutor, no puede ser de otro 
    try{
      console.log("obtener servicios",nombreEmpresa,codigo);
      const response = await api.get(`/contabilidad/getServicioPorCodigo/${nombreEmpresa}/${codigo}`);
    
      if (response.data && response.data.data) {
        return response.data.data;
      }

      return response.data;
    
    }
    catch(error){
       console.error('Error al obtener el servicio:', error);
      throw error;
    }
  },
  //obtener servicio por id de solicitud
  obtenerServicioPorIdSolicitud: async(idSolicitud,nombreEmpresa) =>{
    try{
      const response = await api.get(`/contabilidad/getServicioPorIdSolicitud/${nombreEmpresa}/${idSolicitud}`);

      if (response.data && response.data.data) {
        return response.data.data;
      }

      return response.data;
    }
    catch(error){
      console.error('Error al obtener el servicio por obtenerServicioPorIdSolicitud:', error);
      throw error;
    }
  },
  entregarTrabajoTutor : async(entregaData,codigo,nombreEmpresa,cambiadoPor) =>{
    try{
      const formData = new FormData();
      formData.append('entregaData', JSON.stringify(entregaData));
      formData.append('codigo', codigo); // codigo = "123" se mantiene como "123"
      formData.append('nombreEmpresa', nombreEmpresa); // nombreEmpresa = "DUFY" se mantiene como "DUFY"
      formData.append('cambiadoPor', cambiadoPor);
      const archivos = entregaData.trabajos;

      if (archivos && archivos.length > 0) {
      for (let i = 0; i < archivos.length; i++) {
        formData.append('trabajos', archivos[i]);
      }
      } else {
        return {
          success: false,
          message: 'Debes subir al menos un archivo'
        };
      }

    
      //enviar peticion
      const response = await api.post('/contabilidad/addEntregaTutor', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al enviar información, notifica al administrador'
        };
      }

    }
    catch(error){
      console.error('Error al entregar trabajo tutor:', error);
      throw error;
    }
  },
  entregaTrabajoParcial: async(entregaData,codigo,nombreEmpresa,idEntrega) =>{
    try{
       const formData = new FormData();
       formData.append('entregaData', JSON.stringify(entregaData));
       formData.append('codigo', codigo);
       formData.append('nombreEmpresa', nombreEmpresa); 
       formData.append('idEntrega', idEntrega); 
       const archivos = entregaData.trabajos;

      if (archivos && archivos.length > 0) {
        for (let i = 0; i < archivos.length; i++) {
          formData.append('trabajos', archivos[i]);
        }
      } else {
        return {
          success: false,
          message: 'Debes subir al menos un archivo'
        };
      }

      //enviar peticion
      const response = await api.post('/contabilidad/addEntregaParcial', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al enviar información, notifica al administrador'
        };
      }

    }
    catch(error){
      console.error('Error al entregar trabajo parcial:', error);
      return false;
    }
  },
  getArchivosEntregaTutor : async(codigo,isEntregaParcial,idEntrega,nombreEmpresa) =>{
    try{
      console.log("ger archivos entregados de tyutir",codigo);
      const response = await api.get(`/contabilidad/getEntregaTutorArchivos`, {
              params: {
                codigo,
                isEntregaParcial,
                idEntrega,
                nombreEmpresa,
              }
            }); 

            console.log("respondse",response);

      return response.data;

    }
    catch(error){
      console.error('Datos de respuesta:', error.response.data);
      throw error;
    }
  },
  addServicio: async(servicioData, updateCliente, nombreEmpresa,actualizarClienteApi) => {     
    console.log("a subir servicio en http");     
    try{        
        const dataToSent = {         
            servicio: servicioData,         
            cliente: updateCliente,  
            actualizarCliente : actualizarClienteApi,     
        }        
        
        const response = await api.post(`/contabilidad/addServicioAgendado/${nombreEmpresa}`, dataToSent);        
        console.log("tenemos response", response);              
        
        if (response.data && response.data.success) {          
            return {           
                success: true,           
                message: response.data.message,
                servicio: response.data.servicio // Agregar código si lo necesitas         
            };       
        } else {          
            return {           
                success: false,           
                message: response.data.message || 'Error al subir el servicio'         
            };       
        }      
    }     
    catch(error){       
        console.error('Error al añadir servicio:', error);       
        console.log("error", error);       
        throw error;     
    }   
  },
  obtenerServiciosAdmin: async(nombreEmpresa, fechaIncio, fechaFinal) =>{
    console.log("obtener servicios admin");
    try{
      const response = await api.get(`/contabilidad/getServiciosDiponiblesAdmin/${nombreEmpresa}/${fechaIncio}/${fechaFinal}`);
      console.log("response de servicios",response);
      const data = response.data.data;
      return response.data.data; // Retorna directamente el array de solicitudes
    }
    catch(error){
      console.error('Error al obtener servidios de administrador:', error);
      throw error;
    }
  },
  obtenerServiciosCliente: async(nombreEmpresa,numeroCliente) =>{
    console.log("obtener servicios de cliente",nombreEmpresa,numeroCliente);
    try{
      const response = await api.get(`/contabilidad/getServiciosCliente/${nombreEmpresa}/${numeroCliente}`);
      const data = response.data.data;
      return data;
    }
    catch(error){
      console.error('Error al obtener servicios de clientes:', error);
      throw error;
    }
  },
  //busqueda de servicios
  //busqueda de servicios
  searchServicios: async(nombreEmpresa, busqueda ='') =>{
    try{
      // 1. Define la RUTA RELATIVA
      const relativeUrl = `/contabilidad/obtenerServicios/${nombreEmpresa}`;

      // 2. Prepara los parámetros para Axios
      const config = {
        params: {}
      };

      if (busqueda && busqueda.trim()) {
        config.params.busqueda = busqueda.trim();
      }

      // 3. ✅ USA api.get()
      const response = await api.get(relativeUrl, config);
      
      // 4. ✅ Axios ya devuelve los datos en .data
      return response.data;
    }
    catch(error){
      console.error('❌ Error al obtener servicios:', error);
      throw error;
    }
  },
  //acutlaizar servicio
  updateServicio: async(nombreEmpresa,codigo,type,updateData,cambiadopor,archivos) =>{
    try{
      const formData = new FormData();

      formData.append('servicioData', JSON.stringify(updateData));
      
      // Agregar archivos
      archivos.forEach((archivo, index) => {
        formData.append('archivos', archivo);
        console.log(`📎 Archivo ${index + 1}: ${archivo.name} (${archivo.size} bytes)`);
      });

      const response = await api.post(`/contabilidad/updateServicioAgendado/${nombreEmpresa}/${codigo}/${type}/${cambiadopor}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al actualizar el servicio'
        };
      }

    }
    catch(error){
      console.error('Error al actualizar el servicio:', error);
    
      // Extraer el mensaje de error del servidor si está disponible
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : 'Error al actualizar el servicio';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //añadir pago
  addPago: async(pagoData, nombreEmpresa ,codigo, cambiadopor) =>{
    try{
      console.log("a enviar pagodata",pagoData);
      const formData = new FormData();
      formData.append('archivoPago', pagoData.archivoPago);
      const datosLimpios = { ...pagoData };
      delete datosLimpios.archivoPago;
      delete datosLimpios.id;
      formData.append('pagoData', JSON.stringify(datosLimpios));

      const response = await api.post(`/contabilidad/addPago/${nombreEmpresa}/${codigo}/${cambiadopor}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      console.log("responde datao",response);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al añadir pago'
        };
      }

    }
    catch(error){
      console.error('Error al añadir pago:', error);
      console.log("error",error);
      return {
          success: false,
          message: error.response.data.message || 'Error al añadir pago'
        };
    }
  },
  //delete pago
  deletePago: async(PagoId, nombreEmpresa, codigo, cambiadopor) =>{
    try{
      const response = await api.post(`/contabilidad/deletepago/${nombreEmpresa}/${codigo}/${PagoId}/${cambiadopor}`);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
        };
      } else{
        return {
          success: false,
          message: response.data.message || 'Error al eliminar el pago'
        };
      }

    }
    catch(error){
      console.error('Error al eliminar pago:', error);
      console.log("error",error);
      return {
          success: false,
          message: error.response.data.message || 'Error al eliminar pago'
        };
    }
  },
  //añadir entrega parcial
  addEntregaParcial: async(entregaData, nombreEmpresa, codigo,cambiadoPor) =>{
    try{
      console.log("entrega parcial cambiado por",cambiadoPor);
      const response = await api.post(`/contabilidad/addEntregaParcial/${nombreEmpresa}/${codigo}/${cambiadoPor}`, entregaData);        

      if (response.data && response.data.success) {          
            return {           
                success: true,           
                message: response.data.message,
                servicio: response.data.servicio // Agregar código si lo necesitas         
            };       
        } else {          
            return {           
                success: false,           
                message: response.data.message || 'Error al subir el servicio'         
            };       
        }   
        
    }
    catch(error){
      console.error('Error al añadir la entrega parcial:', error);       
      console.log("error", error);       
      throw error;   
    }
  },
  //eliminar entrega parcial
  deleteEntregaParcial: async(entregaId,nombreEmpresa,codigo,cambiadopor) =>{
    try{
      const response = await api.post(`/contabilidad/deleteEntregaParcial/${nombreEmpresa}/${codigo}/${entregaId}/${cambiadopor}`);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
        };
      } else{
        return {
          success: false,
          message: response.data.message || 'Error al eliminar el pago'
        };
      }

    }
    catch(error){
      console.error('Error al eliminar pago:', error);
      console.log("error",error);
      return {
          success: false,
          message: error.response.data.message || 'Error al eliminar pago'
        };
    }
  },

  searchPagoDrive: async(nombreEmpresa , nombreArchivo) =>{
    console.log("buscando search en drive",nombreEmpresa,nombreArchivo);
    try{
      const response = await api.get(`/contabilidad/searchPago/${nombreEmpresa}/${nombreArchivo}`);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
          data: response.data,
        };
      }
      else{
        return {
          success: false,
          message: response.data.message || 'Error al actualizar el servicio',
          data: null,
        };
      }

    }
    catch(error){
      return {
        success: false,
        message: error.response.data.message,
        error: error
      };
    }
  },
  //obtener estadisitcas de tutor, adicional pago, etc
  estadisticasPagosTutor: async(nombreEmpresa, nameTutor) =>{
    try{
      const response = await api.get(`/contabilidad/obtenerPagosTutor/${nombreEmpresa}/${nameTutor}`);
      console.log("obtenido",response);
      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
          data: response.data.data,
        };
      }
      else{
        return {
          success: false,
          message: response.data.message || 'Error al actualizar el servicio',
          data: null,
        };
      }

    }
    catch(error){
      return {
        success: false,
        message: error.response.data.message,
        error: error
      };
    }
  },
  //Obtener pagos asociados a una referencia y fecha
  getPagosReferencias: async(fechaBusqueda, nombreEmpresa, referencia) =>{
    try{
      
      const response = await api.get(`/contabilidad/obtenerPagosReferencia/${nombreEmpresa}/${referencia}/${fechaBusqueda}`);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
          data: response.data,
        };
      }
      else{
        return {
          success: false,
          message: response.data.message || 'Error al obtener pagos asociados',
          data: null,
        };
      }

    }
    catch(error){
      return {
        success: false,
        message: error.response.data.message,
        error: error
      };
    }
  }
}
//api de configuracion
export const configuracionApi = {
  getConfiguracion : async() =>{
    try{
      const nombreEmpresa = await obtenerNombreEmpresaConReintentos();
      //console.log("obteniendo configuracion de ",nombreEmpresa);

      if (!nombreEmpresa) {
        console.warn("⚠️ Abortando getConfiguracion: No se pudo obtener el nombre de la empresa.");
        return null; // O puedes lanzar un error según prefieras
      }
      
      const response = await api.get(`configuracion/getConfiguracion/${nombreEmpresa}`);

      console.log("configuracion obtenida",response);
      return response.data.data;
    }
    catch(error){
      console.error('Error al obtener configuracion de dufy', error);
      throw error;
    }
  },
  updateConfiguracion: async (nombreEmpresa,finalUpdateData,type,categoria) => {
    try {
      console.log("a update configuracion",nombreEmpresa,finalUpdateData,type,categoria);
        const response = await api.post(`/configuracion/updateConfiguracion/${nombreEmpresa}/${type}/${categoria}`, finalUpdateData);
        
        // ✅ Retornar la respuesta completa del servidor
        return response.data; // Esto contiene { success: true, message: "..." }
    } catch (error) {
        console.error('❌ Error al actualizar la configuracion', error);
        throw error;
    }
  },
  deleteCuentaProfesional: async(nombreEmpresa,cuentaProfesional) =>{
    try{
      const response = await api.post(`/configuracion/deleteCuentasProfesionales/${nombreEmpresa}`, cuentaProfesional);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
        };
      } else{
        return {
          success: false,
          message: response.data.message || 'Error al enviar la cotización'
        };
      }

    }catch(error){

      console.error('Error al eliminar la cotizacion', error);
      return {
        success: false,
        message: error,
        error: error
      };

    }
  },
  repararIndicesSolicitudes: async() =>{
    try{
      const response = await api.get(`/listas/arreglarIndices/`);
      const data = response.data.data;
      return data;
    }
    catch(error){
      console.error('Error al repararIndices:', error);
      throw error;
    }
  },
  repararPrecios: async() =>{
    try{
      const nombreEmpresa = await obtenerNombreEmpresaConReintentos();
      const response = await api.get(`/listas/repararPrecios/${nombreEmpresa}`);
      const data = response.data;
      return data;
    }
    catch(error){
      console.error('Error al repararIndices:', error);
      throw error;
    }
  }
  
}
//api de clientes
export const clientesApi = {
  getClientes: async (nombreEmpresa, busqueda = '') => {
    try {
      console.log("busqueda", nombreEmpresa, busqueda);
      
      // 1. Define la RUTA RELATIVA (sin API_URL)
      const relativeUrl = `/clientes/obtenerClientes/${nombreEmpresa}`;

      // 2. Prepara los parámetros para Axios
      const config = {
        params: {}
      };
      
      if (busqueda && busqueda.trim()) {
        config.params.busqueda = busqueda.trim();
      }
      
      console.log("🌐 Llamando a api.get:", relativeUrl, "Config:", config);

      // 3. ✅ USA api.get()
      // Esto SÍ usará tu interceptor y añadirá el token
      const response = await api.get(relativeUrl, config);

      // 4. ✅ Axios ya devuelve los datos en formato JSON en la propiedad `data`
      console.log("📊 Datos recibidos:", response.data);
      
      return response.data;
      
    } catch (error) {
      console.error('❌ Error al obtener clientes:', error);
      throw error;
    }
  },
  addCliente: async(nombreEmpresa,clienteData) => {
    try{
      const response = await api.post(`/clientes/addCliente/${nombreEmpresa}`,clienteData);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al añadir cliente'
        };
      }

    }
    catch(error){
      console.error('Error al añadir cliente', error);
    
      // Extraer el mensaje de error del servidor si está disponible
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : 'Error al añadir cliente';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //OBTENER CLIENTES
  getClientePorNumero: async(nombreEmpresa,numero) =>{
    try{

      console.log("obtener clientes por numero",nombreEmpresa,numero);

      const response = await api.get(`/clientes/obtenerClientePorNumero/${nombreEmpresa}/${numero.toString()}`);
      console.log("obteniendo cliente",response);
      return response.data.data;
    }
    catch(error){
      console.error('❌ Error al obtener cliente:', error);
      throw error;
    }
  },

  //clientes de plataforma
  getClientesPlataforma: async() =>{
    try{
      const nombreEmpresa = await obtenerNombreEmpresaConReintentos();
      const response = await api.get (`/clientes/obtenerClientesProPlataforma/${nombreEmpresa}`);
      console.log("opbtener clientes plataforma",response);
      const data = response.data.data;
      return data;
    }
    catch(error){
      console.error('Error al obtener los clientes proPlataforma:', error);
      throw error;
    }
  },
  //all clientes
  getAllClientes: async(nombreEmpresa) =>{
    try{
      const response = await api.get ('/clientes/obtenerTodosClientes');
      const data = response.data.data;
      return data;
    }
    catch(error){
      console.error('Error al obtener all clientes:', error);
      throw error;
    }
  },
  //lista de campañas
  getCamapaList : async(nombreEmpresa) =>{
    try{
      const response = await api.get ('/clientes/obtenerlistaCampana');
      const data = response.data.data;
      return data;
    }
    catch(error){
      console.error('Error al obtener la lista de campañas:', error);
      throw error;
    }
  },
  //actualziar cliente
  updateCliente: async(nombreEmpresa,idcliente,type,updateData) =>{
    console.log("a enviar para actualziar",nombreEmpresa,idcliente,type,updateData);
    try{
      const response = await api.post(`/clientes/updateCliente/${nombreEmpresa}/${idcliente}/${type}`, updateData);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
          solicitudId: response.data.solicitudId
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al actualizar la solicitud'
        };
      }

    }
    catch(error){
      console.error('Error al actualizar el servicio:', error);
      return {
          success: false,
          message: error || 'Error al actualizar el cliente'
        };
    }
  },
  //eliminar cunetas de cliente
  deleteCuenta: async(nombreEmpresa,numero,cuentaData) =>{
    try{
      const response = await api.post(`/clientes/delete-cuenta-cliente/${nombreEmpresa}/${numero}`, cuentaData);

      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
        };
      } else{
        return {
          success: false,
          message: response.data.message || 'Error al eliminar la cuenta'
        };
      }

    }
    catch(error){
      console.error('Error al eliminar la cuenta', error);
      return {
        success: false,
        message: error,
        error: error
      };
    }
  }

};
//api de estadisticas
export const EstadisticasApi = {
  getEstadisticas: async(nombreEmpresa,fechaInicio,fechaFinal) =>{
    try{
      const body = {
        fechaInicio: fechaInicio,
        fechaFinal: fechaFinal,
      };
      //falta meterle la fecha de inicio y fecha final, de donde van las estadisticas

      // 2. Usar api.post, pasar el body como segundo argumento y corregir la URL
      const response = await api.post(
        `/estadisticas/getEmpresaEstadisticas/${nombreEmpresa}`, // URL corregida sin '}' extra
        body // Se envían las fechas en el cuerpo de la solicitud
      );

      return response.data.data;
    }
    catch(error){
      return {
          success: false,
          message: 'Error al obtener estadisticas'
        };
    }
  },
  getEstadisticasMarketing: async(nombreEmpresa,fechaInicio,fechaFinal) =>{
    try{
      
      const response = await api.get(
        `/estadisticas/getEstadisticasMarketing/${nombreEmpresa}`, {
          // Los parámetros de consulta (query params) se pasan dentro de un objeto 'params'
          params: {
            fechaInicio: fechaInicio,
            fechaFinal: fechaFinal,
          }
        }
      );

      return response.data.data;
    }
    catch(error){
      return {
          success: false,
          message: 'Error al obtener estadisticas de marketing'
        };
    }
  }
};
//costos api
export const costosApi = {
  getCostos: async(nombreEmpresa) =>{
    try{
      const response = await api.get(`/costos/getCostos/${nombreEmpresa}`);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de costos :`, error);
      throw error;
    }
  },
  addCosto: async(nombreEmpresa, costoMap,costoData) => {
    try{
      const formData = new FormData();

      const archivoPago = costoData.archivoPago;
      const archivoFactura = costoData.archivoFactura;

      console.log("archivo pago",archivoPago);

      console.log("archivo pago",archivoPago);
      console.log("archivo factura",archivoFactura);

      if (archivoPago) {
        formData.append('archivoPago', archivoPago);
      }
      if (archivoFactura) {
        formData.append('archivoFactura', archivoFactura);
      }

      formData.append('costoData', JSON.stringify(costoMap));

      
      const response = await api.post(`/costos/addCosto/${nombreEmpresa}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al enviar el costo'
        };
      }
        

    }
    catch(error){
      console.error('Error en addcosto:', error);
      
      const errorMessage = error.response?.data?.message || error.message || 'Error al conectar con el servidor';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  updateCosto: async(documentoId,nombreEmpresa,updateData,type) =>{
    try{

      const response = await api.post(`/costos/updateCosto/${nombreEmpresa}/${documentoId}/${type}/`, updateData);

      console.log("tenemos response",response);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
          solicitudId: response.data.solicitudId
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al actualizar el costo'
        };
      }

    }
    catch(error){
      console.error('Error al actualizar el costo:', error);
    
      // Extraer el mensaje de error del servidor si está disponible
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : 'Error al actualizar el costo';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  getListaConceptos: async(nombreEmpresa) =>{
    try{
      const response = await api.get(`/costos/obtenerConceptos/${nombreEmpresa}`);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de conceptos :`, error);
      throw error;
    }
  },
  getListaProveedores: async(nombreEmpresa) =>{
    try{
      const response = await api.get(`/costos/obtenerProveedores/${nombreEmpresa}`);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de proveedores :`, error);
      throw error;
    }
  },

}
//cuentas de cobro api
export const cuentasCobroApi = {
  addCuentaCobro: async(nombreEmpresa,cuentaCobroData) =>{
    console.log("add cuenta cobro",nombreEmpresa,cuentaCobroData);
    
    try{

      const formData = new FormData();
      formData.append('cuentaCobroData', JSON.stringify(cuentaCobroData));

      for (let [key, value] of formData.entries()) {
        console.log(`✅ Campo: ${key}, Contenido:`, value);
      }

      const response = await api.post(`/cuentascobros/addCuentaCobro/${nombreEmpresa}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al añadir la cuenta de cobro'
        };
      }

    }
    catch(error){
      return {
          success: false,
          message: 'Error al añadir la cuenta de cobro'
        };
    }
        
  },
  updateCuentaCobro: async(idDocumento,nombreEmpresa,cuentaCobroData,type,archivo) =>{
    const formData = new FormData();

    try{
      formData.append('cuentaCobroData', JSON.stringify(cuentaCobroData));
      formData.append('archivoCuentaCobro', archivo.archivoCuentaCobro);
      
      console.log("archivo cuenta",archivo);

      const response = await api.post(`/cuentascobros/updateCuentaCobro/${nombreEmpresa}/${idDocumento}/${type}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        } 
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al actualizar la cuenta de cobro'
        };
      }

    }
    catch(error){
      console.error('Error en update cuenta cobro:', error);
      
      const errorMessage = error.response?.data?.message || error.message || 'Error al conectar con el servidor';
      
      return {
        success: false,
        message: errorMessage,
        error: error
      };
    }
  },
  //get cuentas de cobro
  getCuentasCobro: async(nombreEmpresa) =>{
    try{
      console.log("a obtener cuentas de cobro");
      const response = await api.get(`/cuentascobros/getCuentasCobro/${nombreEmpresa}`);
      console.log("response de get cuenta cobro tutor",response);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de cuentas de cobro :`, error);
      throw error;
    }
  },
  //buscar cuenta de cobro
  getPagosReferenciasAsociadas: async(fechaBusqueda, nombreEmpresa, referencia, nameTutor) =>{
    try{
      const response = await api.get(`/cuentascobros/getPagosAsociadosReferencias/${fechaBusqueda}/${nombreEmpresa}/${referencia}/${nameTutor}`);
      //console.log("resposne arriba",response);
      
      if(response.data && response.data.success){
        return {
          success: true,
          message: response.data.message,
          data: response.data,
        };
      }
      else{
        return {
          success: false,
          message: response.data.message || 'Error al otener referencia asociada',
          data: null,
        };
      }

    }
    catch(error){
      return {
        success: false,
        message: error.response.data.message,
        error: error
      };
    }
  },
  //buscar cuentas de cobro de tutor, info de tutor
  getCuentasCobroTutor: async(nombreEmpresa, nombreTutor) =>{
    try{
      const response = await api.get(`/cuentascobros/getCuentasCobroTutor/${nombreEmpresa}/${nombreTutor}`);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener lista de cuentas de cobro para tutor :`, error);
      throw error;
    }
  },
  //obtener empresas en las que puede cobrar el tutor
  getEmpresasCobro: async(nombreTutor) =>{
    try{
      const response = await api.get(`/cuentascobros/getEmpresasCobro/${nombreTutor}`);
      return response.data.data;
    }
    catch(error){
      console.error(`Error al obtener empresas para cobrar :`, error);
      throw error;
    }
  }

};
//whatsapp api
export const whatsappApi = {
  //obtener chats
  getChats: async(nombreEmpresa,estaArchivado) =>{
    console.log("obteniendo chats");
    try{
      const params = {}
      if (estaArchivado) {
        params.archivado = true;
      }

      const response = await api.get(
        `/whatsapp_comercial/getTodosLosChats/${nombreEmpresa}`, 
        { params } // <-- La librería se encarga de añadirlo a la URL
      );
      
      console.log("obteniendo todos los chats",response);
      return response;   
    }
    catch(error){
      console.error(`Error al obtener lista de chats :`, error);
      throw error;
    }
  },
  //obtener mensajes
  getMensajes: async(nombreEmpresa,numero) =>{
    try{
      const response = await api.get(`/whatsapp_comercial/getTodosLosMensajes/${nombreEmpresa}/${numero}`);
      console.log("obteniendo todos los chats",response);
      return response;   
    }
    catch(error){
      console.error(`Error al obtener lista de mensajes :`, error);
      throw error;
    }
  },
  //actualizar usuario
  updateUsuario: async(phoneNumber, newValue, field) =>{
    try{
      const dataToSent = {         
        phoneNumber: phoneNumber,         
        companyName: 'DUFY ASESORIAS',  
        [field]: newValue,     
      }    

      const response = await api.post(`/whatsapp_comercial/updateUsuario`, dataToSent);        

       if (response.data && response.data.success) {          
            return {           
                success: true,           
                message: response.data.message,
                servicio: response.data.servicio // Agregar código si lo necesitas         
            };       
        } else {          
            return {           
                success: false,           
                message: response.data.message || 'Error al actualizar el estado'         
            };       
        } 

    }
    catch(error){
      console.error('Error al actualizar whatsapp:', error);       
      console.log("error", error);       
      throw error;     
    }
  }
}
//usuarios apoi
export const usuariosApi = {
  //get de usuario by id
  precreateUsuarioCliente: async(usuarioData,contrasena) =>{
    try{

      const dataToSend = {
        usuarioData: usuarioData,  
        contrasena: contrasena 
      };

      const response = await api.post(`/usuarios/preregistroCliente`, dataToSend);

      console.log("response",response)

       return response.data;
    }
    catch(error){
      console.error('Error al createUsuarioCliente:', error);
      throw error;
    }
  },
  //crear usuario
  verificarOtpyCrear: async(identificador,codigoOTP,usuarioData,yavalidado=false) =>{
    try{
      const dataToSend = {
        usuarioData: usuarioData,  
        contrasena: usuarioData.contrasena,
        codigoOTP: codigoOTP,
        identificador: identificador,
        yaValidado: yavalidado,
      };

      const response = await api.post(`/usuarios/registroCliente`, dataToSend);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al crear la cuenta'
        };
      }

    }
    catch(error){
      console.error('Error al verificarOtpyCrear:', error);
      throw error;
    }
  },
  getById: async(uid) =>{
    try{
      console.log("get by id",uid);
      const nombreEmpresa = await obtenerNombreEmpresaConReintentos();
      const isCliente = isClientes;
      console.log("antes de ejecutar",nombreEmpresa,isCliente,uid);
      const response = await api.get(`/usuarios/obtenerUsuarioPorId/${uid}/${nombreEmpresa}/${isCliente}`);
      console.log("response getbyid",response);
      return response.data;
    }
    catch(error){
      console.error(`Error al obtener usuario ${uid}:`, error);
      throw error;
    }
  },
  //cambio de contraseña
  generateCambioContrasena: async(correoElectronico) =>{
    try{

       const response = await api.get(`/usuarios/cambioContrasena/${correoElectronico}`);

      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message,
        };
      } else {
        // Si la API respondió, pero no fue exitoso
        return {
          success: false,
          message: response.data.message || 'Error al cambiar contraseña'
        };
      }

    }
    catch(error){
      console.error('Error al verificarOtpyCrear:', error);
      throw error; 
    }
  },
  //obtener usuario por correo
  getUserByCorreo: async (correo) => {
  try {
    // Realiza la petición GET al endpoint que configuramos
    const response = await api.get(`/usuarios/obtenerUsuarioPorCorreo/${correo}`);

    // Retornamos directamente los datos (que contienen uid, rol, etc.)
    return response.data;

  } catch (error) {
    // Si el backend devuelve 404 o 500, cae aquí
    console.error(`Error al obtener usuario por correo ${correo}:`, error);
    throw error; // Lanzamos el error para que el componente lo maneje
  }
}


}
//pagos api
export const wompiPagosApi = {
  obtenerFirmaIntegral: async (referencia,montoEnCentavos) =>{
    try{
      const dataToSend = {
        referencia: referencia,
        monto: montoEnCentavos,
        moneda: 'COP'
      };
      const response = await api.post(`/wompi/generarfirma`, dataToSend);
      return response.data.firma;
    }
    catch(error){
      console.error('Error al obtener firma de Wompi:', error);
      throw error;
    }
  }
}

//DASHBOARD API
export const DashboardApi ={
  estadisticasClientesProUnad: async(nombreEmpresa, semestre) =>{
    try{
      const response = await api.get(`/listas/obtenerClientesProUnadDashboard/${nombreEmpresa}/${semestre}`);
      console.log("obteniendo tutoires",response);
      return response;
    }
    catch(error){
      console.error(`Error al obtener estadisticas clinetes proUnad:`, error);
      throw error;
    }
  },
  estadisticasTrabajosNoEntregados: async(nombreEmpresa) =>{
     try{
      const response = await api.get(`/listas/obtenerTrabajosNoEntregadosDashboard/${nombreEmpresa}`);
      return response;
    }
    catch(error){
      console.error(`Error al obtener estadisticasTrabajosNoEntregados:`, error);
      throw error;
    }
  },
  estadisticasPagosPendientes: async(nombreEmpresa) =>{
     try{
      const response = await api.get(`/listas/obtenerPagosClientesDashboard/${nombreEmpresa}`);
      console.log("obteniendo tutoires",response);
      return response;
    }
    catch(error){
      console.error(`Error al obtener estadisticasPagosPendientes:`, error);
      throw error;
    }
  },
  estadisticasAsesoriasSinEnlace: async(nombreEmpresa) =>{
     try{
      const response = await api.get(`/listas/obtenerAsesoriasEnlace/${nombreEmpresa}`);
      console.log("obteniendo tutoires",response);
      return response;
    }
    catch(error){
      console.error(`Error al obtener estadisticasPagosPendientes:`, error);
      throw error;
    }
  },

  //proplataforma
  obntenerPlataforma: async(nombreEmpresa,plataforma) =>{
     try{
      const response = await api.get(`/listas/obtenerCotizacionPlataformas/`);
      return response;
    }
    catch(error){
      console.error(`Error al obtener estadisticasPagosPendientes:`, error);
      throw error;
    }
  },
  //obtener servicios por agendar
  getServiciosPorAgendar: async(nombreEmpresa) =>{
    try{
      const response = await api.get(`/estadisticas/getSolicitudesPorAgendar/${nombreEmpresa}`);
      console.log("response obtenida",response);
      return response;
    }
    catch(error){
      console.error(`Error al obtener estadisticasPagosPendientes:`, error);
      throw error;
    }
  },
  //obtener servicios por revisar
  getServiciosPorRevisar: async(nombreEmpresa, tutor = null) =>{
    try{

      const config = {
        params: tutor ? { tutor } : {}
      };
      
      const response = await api.get(`/estadisticas/getRevisionesServicios/${nombreEmpresa}`, config);

      console.log("response obtenida",response);
      return response;
    }
    catch(error){
      console.error(`Error al obtener getServiciosPorRevisar:`, error);
      throw error;
    }
  },

  getPagosReferidos: async(nombreEmpresa) =>{
    try{
    
      const response = await api.get(`/estadisticas/getPagosReferidos/${nombreEmpresa}`);

      return response.data.data;
    }
    catch(error){
      console.error(`Error al obtener getServiciosPorRevisar:`, error);
      throw error;
    }
  },

}

//WOMPI API
export const WompiApi = {
  getStatusTransacion : async() =>{
    
  }
}

//EMAIL MARKETING API
export const CorreoMarketingApi = {
  obtenerDestinatarios : async(nombreEmpresa,tipo,universidad,carrera) =>{
    try{
      const params = new URLSearchParams({
        tipo: tipo,
        universidad: universidad,
        carrera: carrera,
      });
      const response = await api.get(`/correos/destinatarios/${nombreEmpresa}?${params.toString()}`);
      
      console.log("obteniendod estinatarios",response);
      return response;
    }
    catch(error){
      console.error(`Error al obtener obtenerDestinatarios:`, error);
      throw error;
    }
    
  },
  //oibteener plantillas en cache, estaticas
  obtenerPlantillas: async() =>{
    try{

      const response = await api.get(`/correos/plantillas`);
      return response;
    }
    catch(error){
      console.error(`Error al obtener CorreoMarketingApi:`, error);
      throw error;
    }
    
  },
  //obtener plantillas almacenadas en base de datos
  obtenerPlantillasPersonalizadas: async(nombreEmpresa) =>{
    try{
      const response = await api.get(`/correos/plantillasGuardadas/${nombreEmpresa}`);
      return response;
    }
    catch(error){
      console.error(`Error al obtener obtenerPlantillasPersonalizadas:`, error);
      throw error;
    }
  },

  //crear plantilla
  newPlantilla: async (data) => {
    try {
      const response = await api.post(`/correos/newPlantilla`, data);
      return response.data; // 🌟 CORREGIDO: Retornamos los datos limpios de Axios
    }
    catch (error) {
      console.error(`Error al obtener newPlantilla:`, error);
      throw error;
    }
  },

  /*
    CAMPAÑAS
  */
  //crear campaña
  createCampana: async (nombreEmpresa, data) => {
    try {
      // Apuntamos al endpoint de despacho masivo pasando el nombre de la empresa parametrizado
      const response = await api.post(`/correos/campanas/despachar/${nombreEmpresa}`, data);
      return response.data; // Retornamos los datos limpios desestructurados de Axios
    }
    catch (error) {
      console.error(`Error al procesar createCampana:`, error);
      throw error;
    }
  },
  //Obtener campañas
  obtenerCampanas: async (nombreEmpresa) => {
    try {
      const response = await api.get(`/correos/campanas/${encodeURIComponent(nombreEmpresa)}`);
      return response.data; // Desempaquetamos Axios de forma segura (.data)
    }
    catch (error) {
      console.error(`Error al invocar obtenerCampanas:`, error);
      throw error;
    }
  },
  //log de correos
  obtenerLogsCorreos: async (nombreEmpresa, page = 1, limit = 20) => {
    try {
      const response = await api.get(`/correos/logs/${nombreEmpresa}?page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error("Error en obtenerLogsCorreos API:", error);
      throw error;
    }
  }

}



export default api;